import { inject, provideAppInitializer } from '@angular/core';
import { KeycloakClient } from '@core/services/keycloak/keycloak.client';
import { environment } from '@environments/environment';
import Keycloak from 'keycloak-js';

const realmId = window.location.hostname
  .replace('.pacemaker.ai', '')
  .replace(/\./g, '_');

const keycloakUrl = environment.sso.keycloakUrl;

export const provideKeycloakAngular = () =>
  provideAppInitializer(async () => {
    const keycloakClient = inject(KeycloakClient);

    keycloakClient.setKeycloakInstance(
      new Keycloak({
        url: keycloakUrl,
        realm: realmId,
        clientId: environment.sso.keycloakClientId,
      }),
    );

    return keycloakClient.getKeycloakInstance().init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
    });
  });
